import React from 'react';
import { Link } from 'react-router-dom';
import { getRoutePath } from '@/app/router/route-registry';
import { MetricCard } from '@/shared/components/patterns';
import '@/modules/dashboard/styles/DashboardStatsGrid.css';

const metricIconMap = {
  assignments: 'nav.tasks',
  deals: 'nav.dealsActive',
  events: 'nav.calendar',
  urgent: 'status.warning',
  default: 'metrics.document',
};

export default function DashboardStatsGrid({ statsCards = [] }) {
  return (
    <div className="dashboard-stats-grid">
      {statsCards.map((card) => {
        const linkTarget = getRoutePath(card.routeId);
        const linkSearch = card.search || '';

        return (
          <Link
            key={`${card.title}-${linkTarget}${linkSearch}`}
            to={`${linkTarget}${linkSearch}`}
            className="dashboard-stats-grid__link"
          >
            <MetricCard
              label={card.title}
              value={card.value}
              iconKey={metricIconMap[card.variant] || metricIconMap.default}
              tone={card.variant === 'urgent' ? 'attention' : 'neutral'}
            />
            {card.subtitle ? (
              <span className="dashboard-stats-grid__subtitle">{card.subtitle}</span>
            ) : null}
          </Link>
        );
      })}
    </div>
  );
}
